import { render, staticRenderFns } from "./PlacementGoals.vue?vue&type=template&id=41068c6d"
import script from "./PlacementGoals.vue?vue&type=script&lang=js"
export * from "./PlacementGoals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports